/*
 * @Author: cc
 * @LastEditTime: 2025-12-22 10:20:51
 */
import { UserAddOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Tabs, message } from 'antd';
import { encode } from 'js-base64';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { post } from '../../../component/fetch';
import { isPc } from '../../../utils/index';
import SetPassword from '../setPassword';
import Signup from '../signup';
import './index.scss';

// 移动端组件动态导入
let MobileModal: any;

const { REACT_APP_BASE_PC_URL, REACT_APP_BASE_MOBILE_URL } = process.env;
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
const { Search } = Input;

/**密码登录组件 */
const PasswordLogin = (props: any) => {
  const query = useQuery();
  /** 获取地址栏参数*/
  const projectId = query.get('projectId');
  const [randomImgUrl, setRandomImgUrl] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  /**获取短信验证码 */
  const getRandomCode = () => {
    fetch(`/main/ran/random`)
      .then(
        response => response.blob(),
        error => console.log('An error occurred.', error)
      )
      .then((blob: any) => {
        const randomImgUrl = window.URL.createObjectURL(blob);
        setRandomImgUrl(randomImgUrl);
      });
  };
  /**表单提交事件 */
  const onFinish = (val: any) => {
    let data = { ...val };
    data.userName = encode(data.userName);
    data.password = encode(data.password);
    data.randomCode = encode(data.randomCode);
    data.projectId = projectId;
    post('/user/api/user/loginWithUnify', data, true).then(res => {
      if (res.code === 0) {
        if (isPc) {
          window.location.href =
            props.initData.courseSource === 1
              ? `${REACT_APP_BASE_PC_URL}/#/projectInfo?projectId=${projectId}&fromUrl=${btoa(
                  window.location.href
                )}`
              : `${REACT_APP_BASE_PC_URL}/#/cePayProjectInfo?projectId=${projectId}&projectType=1`;
        } else {
          window.location.href =
            props.initData.courseSource === 1
              ? `${REACT_APP_BASE_MOBILE_URL}/#/projectInfo?projectId=${projectId}&fromUrl=${btoa(
                  window.location.href
                )}`
              : `${REACT_APP_BASE_MOBILE_URL}/#/cePayProjectInfo?projectId=${projectId}&projectType=1`;
        }
      } else {
        message.error(res.data.msg);
      }
    });
  };
  useEffect(() => {
    getRandomCode();
  }, []);
  return (
    <Form className="loginForm" onFinish={onFinish}>
      <Form.Item name="userName" rules={[{ required: true, message: '请输入您的手机号码' }]}>
        <Input placeholder="请输入手机号"></Input>
      </Form.Item>
      <Form.Item name="password" rules={[{ required: true, message: '请输入您的密码' }]}>
        <Input.Password
          visibilityToggle={{
            visible: passwordVisible,
            onVisibleChange: setPasswordVisible,
          }}
          placeholder="请输入密码"
        ></Input.Password>
      </Form.Item>
      <Form.Item name="randomCode" rules={[{ required: true, message: '请输入图形验证码' }]}>
        <Search
          className="searchInput"
          placeholder="请输入图形验证码"
          enterButton={<img src={randomImgUrl} alt="验证码" onClick={getRandomCode} />}
          style={{ padding: '0' }}
          size="large"
        />
      </Form.Item>
      <Form.Item style={{ marginTop: '20px' }}>
        <Button type="primary" htmlType="submit">
          登录
        </Button>
      </Form.Item>
    </Form>
  );
};
/** 短信验证码登录组件*/
const SmsLogin = (props: any) => {
  const [randomImgUrl, setRandomImgUrl] = useState('');
  const [smsForm] = Form.useForm();
  const query = useQuery();
  /** 获取地址栏参数*/
  const projectId = query.get('projectId');
  // /**获取图形验证码 */
  const getRandomCode = () => {
    fetch(`/main/ran/random`)
      .then(
        response => response.blob(),
        error => console.log('An error occurred.', error)
      )
      .then((blob: any) => {
        const randomImgUrl = window.URL.createObjectURL(blob);
        setRandomImgUrl(randomImgUrl);
      });
  };
  /**表单提交事件 */
  const onFinish = (val: any) => {
    let data = { ...val };
    data.mobile = encode(data.mobile);
    data.smsCode = encode(data.smsCode);
    data.projectId = projectId;
    delete data.randomCode;
    post('/user/api/user/mobileAndSmsLoginWithUnify', data, true).then(res => {
      if (res.code === 0) {
        if (isPc) {
          window.location.href =
            props.initData.courseSource === 1
              ? `${REACT_APP_BASE_PC_URL}/#/projectInfo?projectId=${projectId}&fromUrl=${btoa(
                  window.location.href
                )}`
              : `${REACT_APP_BASE_PC_URL}/#/cePayProjectInfo?projectId=${projectId}&projectType=1`;
        } else {
          window.location.href =
            props.initData.courseSource === 1
              ? `${REACT_APP_BASE_MOBILE_URL}/#/projectInfo?projectId=${projectId}&fromUrl=${btoa(
                  window.location.href
                )}`
              : `${REACT_APP_BASE_MOBILE_URL}/#/cePayProjectInfo?projectId=${projectId}&projectType=1`;
        }
      }
    });
  };
  /** 获取短信验证码事件*/
  const getSmsCode = () => {
    const mobile = smsForm.getFieldValue('mobile');
    const randomCode = smsForm.getFieldValue('randomCode');
    if (!mobile) {
      message.info('请填写手机号');
      return;
    }
    if (!randomCode) {
      message.info('请填写图形验证码');
      return;
    }
    post(
      `/user/api/user/sendSmsCodeWithUnify`,
      {
        mobile: encode(mobile),
        randomCode: encode(randomCode),
        smsTitle: props.initData.smsTitle,
      },
      true
    ).then(res => {
      message.success('短信成功发送');
    });
  };
  useEffect(() => {
    getRandomCode();
  }, []);
  return (
    <Form className="loginForm" form={smsForm} onFinish={onFinish}>
      <Form.Item name="mobile" rules={[{ required: true, message: '请输入您的图形验证码' }]}>
        <Input placeholder="请输入手机号"></Input>
      </Form.Item>
      <Form.Item name="randomCode" rules={[{ required: true, message: '请输入您的图形验证码' }]}>
        <Search
          className="searchInput"
          placeholder="请输入图形验证码"
          enterButton={<img src={randomImgUrl} alt="验证码" onClick={getRandomCode} />}
          style={{ padding: '0' }}
          size="large"
        />
      </Form.Item>
      <Form.Item name="smsCode" rules={[{ required: true, message: '请输入您的短信验证码' }]}>
        <Search
          placeholder="请输入短信验证码"
          className="searchInput"
          enterButton={
            <Button type="primary" onClick={getSmsCode}>
              获取验证码
            </Button>
          }
          style={{ padding: '0' }}
          size="large"
        />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          登录
        </Button>
      </Form.Item>
    </Form>
  );
};

/** 登录页面组件*/
function Index(props: any) {
  const query = useQuery();
  const projectId = query.get('projectId');
  //顶部选中tab值
  const [tab, setTab] = useState(1);
  //tab选项
  const [nav, setNavs] = useState([
    {
      key: 1,
      label: '密码登录',
    },
    {
      key: 2,
      label: '验证码登录',
    },
  ]);
  const [content, setContent] = useState();
  //在线客服开关
  const [isModalOpen, setIsModalOpen] = useState(false);
  // 移动端组件加载状态
  const [mobileComponentsLoaded, setMobileComponentsLoaded] = useState(false);

  // 动态加载移动端组件
  const loadMobileComponents = async () => {
    if (!isPc) {
      try {
        const antdMobile = await import('antd-mobile');
        MobileModal = antdMobile.Modal;
        setMobileComponentsLoaded(true);
      } catch (error) {
        console.warn('antd-mobile加载失败，使用PC端组件');
        setMobileComponentsLoaded(false);
      }
    }
  };

  //获取默认信息调整tab位置
  useEffect(() => {
    const { unifyPasswordLoginFlag, unifyPasswordLoginIndex, unifySmsLoginFlag } = props.initData;
    if (unifyPasswordLoginFlag && unifySmsLoginFlag) {
      if (unifyPasswordLoginIndex === 2) {
        let newNavs = [...nav];
        let passwordIndex = newNavs.findIndex(item => item.label === '密码登录');
        let password = newNavs[passwordIndex];
        newNavs.splice(passwordIndex, 1);
        newNavs.push(password);
        newNavs.forEach((item, index) => (item.key = index + 1));
        setNavs(newNavs);
        setContent(newNavs[0]);
      } else {
        setContent(nav[0]);
      }
    } else {
      if (!unifyPasswordLoginFlag) {
        let newNavs = [...nav];
        let passwordIndex = newNavs.findIndex(item => item.label === '密码登录');
        passwordIndex !== -1 && newNavs.splice(passwordIndex, 1);
        newNavs.forEach((item, index) => (item.key = index + 1));
        setNavs(newNavs);
        setContent(newNavs[0]);
      } else {
        let newNavs = [...nav];
        let smsIndex = newNavs.findIndex(item => item.label === '验证码登录');
        smsIndex !== -1 && newNavs.splice(smsIndex, 1);
        newNavs.forEach((item, index) => (item.key = index + 1));
        setNavs(newNavs);
        setContent(newNavs[0]);
      }
    }
  }, [props.initData]);
  // useEffect(() => {
  //   const index = nav.findIndex((item: any) => item.key === tab)
  //   let Content = nav[index]
  //   setContent(Content)
  // }, [tab])

  useEffect(() => {
    loadMobileComponents();
  }, []);

  useEffect(() => {
    console.log(nav);
  }, [nav]);
  /**切换tab事件 */
  const onChange = (key: string) => {
    setTab(key);
    const index = nav.findIndex((item: any) => item.key === key);
    let Content = nav[index];
    setContent(Content);
  };
  //修改密码接口调用
  function setPassword(val: any) {
    const { mobile, smsCode, password } = val;
    post(
      `/user/api/user/modifyPasswordWithUnify`,
      {
        mobile,
        smsCode,
        password,
      },
      true
    ).then(res => {
      if (res.code === 0) {
        message.success('设置成功');
        setTab(1);
      }
    });
  }
  const [signupVisible, setSignupVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  // 处理报名提交
  const handleSignupSubmit = (result: any) => {
    console.log('报名结果:', result);
    // 报名成功后关闭弹窗
    if (result && result.code === 0) {
      setTimeout(() => {
        setVisible(false);
      }, 1500); // 延迟关闭，让用户看到成功提示
    }
  };

  // 渲染在线客服Modal
  const renderServiceModal = () => {
    const modalContent = (
      <div
        dangerouslySetInnerHTML={{
          __html: props.initData.onlineServiceContent,
        }}
      ></div>
    );

    if (!isPc && mobileComponentsLoaded && MobileModal) {
      return (
        <MobileModal
          visible={isModalOpen}
          content={modalContent}
          closeOnAction
          onClose={() => setIsModalOpen(false)}
          title={props.initData.onlineServiceName || '在线客服'}
          actions={[
            {
              key: 'close',
              text: '关闭',
              onClick: () => setIsModalOpen(false),
            },
          ]}
        />
      );
    }

    return (
      <Modal
        title={props.initData.onlineServiceName || '在线客服'}
        open={isModalOpen}
        footer={null}
        onCancel={() => setIsModalOpen(false)}
      >
        {modalContent}
      </Modal>
    );
  };

  return (
    <>
      <div style={{ marginBottom: '20px', textAlign: 'center' }}>
        {props.initData.enrollEntryFlag === 1 && (
          <Button
            type="primary"
            shape="round"
            size="large"
            icon={<UserAddOutlined />}
            onClick={() => setVisible(true)}
            style={{ width: '100%' }}
          >
            报名入口
          </Button>
        )}
      </div>
      {tab === 0 && (
        <SetPassword
          goBack={() => {
            setTab(1);
          }}
          submit={(val: any) => setPassword(val)}
          sendCodeInterface="/user/api/user/sendSmsCodeWithUnify"
        ></SetPassword>
      )}
      {tab !== 0 && (
        <div>
          <Tabs centered activeKey={tab} defaultActiveKey={1} onChange={onChange} items={nav} />

          {/* <div style={{display: content?.label === "密码登录" ? 'block' : 'none'}}>
          <PasswordLogin ></PasswordLogin>
        </div>
        <div style={{display: content?.label === "验证码登录" ? 'block' : 'none'}}>
          <SmsLogin {...props}></SmsLogin>
        </div> */}
          {content?.label === '密码登录' && <PasswordLogin {...props}></PasswordLogin>}
          {content?.label === '验证码登录' && <SmsLogin {...props}></SmsLogin>}
          {projectId !== '3594' && projectId !== '3593' && (
            <p style={{ textAlign: 'right', color: '#1677ff' }}>
              <a
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setTab(0);
                }}
              >
                忘记密码?
              </a>
            </p>
          )}
          {props.initData.onlineServiceFlag !== 0 && (
            <p style={{ textAlign: 'center', color: '#1677ff' }}>
              <a style={{ cursor: 'pointer' }} onClick={() => setIsModalOpen(true)}>
                {props.initData.onlineServiceName ? props.initData.onlineServiceName : '在线客服'}
              </a>
            </p>
          )}

          {/* 渲染在线客服Modal */}
          {renderServiceModal()}

          {/* 报名弹窗 */}
          <Modal
            open={visible}
            onCancel={() => setVisible(false)}
            footer={null}
            title={
              <div
                style={{
                  textAlign: 'center',
                  fontSize: '18px',
                  fontWeight: 'bold',
                }}
              >
                报名
              </div>
            }
            destroyOnClose
            width={450}
            className="signup-modal"
          >
            <Signup onSubmit={handleSignupSubmit} />
          </Modal>
        </div>
      )}
    </>
  );
}
const getInitData = (state: { initData: Array<any> }) => {
  return {
    initData: state.initData,
  };
};
export default connect(getInitData)(Index);
